export default __webpack_public_path__ + "static/media/productHowItWorks2.8a070101.svg";